import React, { Component } from 'react';
import { BeautifulCircleIcon } from './BeautifulCircleIcon';
import { HorizontalLine } from './HorizontalLine';

export class AddWebsiteForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            monthlyVisits: 0,
            visitOptions: [
                { value: 0, label: '0' },
                { value: 10000, label: 'до 10 000' },
                { value: 30000, label: 'до 30 000' },
                { value: 60000, label: 'до 60 000' },
                { value: 100000, label: 'до 100 000' },
                { value: 200000, label: 'до 200 000' },
            ]
        };
    }

    handleVisitsChange = (value) => {
        this.setState({ monthlyVisits: value });
    }

    getCurrentVisitLabel = () => {
        const option = this.state.visitOptions.find(opt => 
            opt.value === this.state.monthlyVisits
        );
        return option ? option.label : '0';
    }

    render() {
        return (
            <div className='chooseNetworkBlock'>
                <div className='whiteBlockTitle'>
                    <BeautifulCircleIcon /> 
                    <div className="whiteBlockTitleSpan">
                        Добавление сайта для защиты
                    </div>
                </div>

                <div className="whiteBlockMiddle">
                    {/* Поле для имени сайта */}
                    <div className="whiteBlockTextInputBlock">
                        <div className="whiteBlockTextInputBlock_label">
                            Название сайта
                        </div>
                        <input
                            type="text"
                            placeholder="Мой сайт"
                            value={this.props.website_name || ''}
                            onChange={this.props.updateWebsiteName}
                            className="lkWrapper inputText"
                            style={{
                                width: '100%',
                                padding: '1.8em',
                                fontSize: '1.2em',
                                marginTop: '0.5em'
                            }}
                        />
                    </div>

                    {/* Поле для ввода URL сайта */}
                    <div className="whiteBlockTextInputBlock" style={{ marginTop: '2em' }}>
                        <div className="whiteBlockTextInputBlock_label">
                            URL сайта
                        </div>
                        <input
                            type="text"
                            placeholder="https://example.com"
                            value={this.props.website_url || ''}
                            onChange={this.props.updateWebsiteUrl}
                            className="lkWrapper inputText"
                            style={{
                                width: '100%',
                                padding: '1.8em',
                                fontSize: '1.2em',
                                marginTop: '0.5em'
                            }}
                        />
                    </div>

                    {/* Блок с ползунком для выбора количества визитов */}
                    <div className="whiteBlockTextInputBlock" style={{ marginTop: '3em' }}>
                        <div className="whiteBlockTextInputBlock_label">
                            Количество визитов в месяц
                        </div>
                        
                        {/* Ползунок */}
                        <div style={{ 
                            marginTop: '2em', 
                            position: 'relative',
                            padding: '0 1em'
                        }}>
                            <input
                                type="range"
                                min="0"
                                max={this.state.visitOptions.length - 1}
                                value={this.state.visitOptions.findIndex(opt => opt.value === this.state.monthlyVisits)}
                                onChange={(e) => {
                                    const index = parseInt(e.target.value);
                                    const value = this.state.visitOptions[index].value;
                                    this.handleVisitsChange(value);
                                }}
                                style={{
                                    width: '100%',
                                    height: '0.6em',
                                    WebkitAppearance: 'none',
                                    background: 'linear-gradient(to right, #0767F4, #30D1E0)',
                                    borderRadius: '1em',
                                    outline: 'none'
                                }}
                            />
                            
                            {/* Отображение текущего значения */}
                            <div style={{
                                textAlign: 'center',
                                marginTop: '1.5em',
                                fontSize: '1.4em',
                                color: '#0767F4',
                                fontWeight: '600'
                            }}>
                                {this.getCurrentVisitLabel()} визитов/месяц
                            </div>
                        </div>

                        {/* Отображение всех вариантов под ползунком */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: '3em',
                            padding: '0 0.5em'
                        }}>
                            {this.state.visitOptions.map((option, index) => (
                                <div 
                                    key={option.value}
                                    style={{
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                        color: this.state.monthlyVisits === option.value ? '#0767F4' : '#9197B3',
                                        fontWeight: this.state.monthlyVisits === option.value ? '600' : '400'
                                    }}
                                    onClick={() => {
                                        this.handleVisitsChange(option.value);
                                    }}
                                >
                                    <div style={{
                                        fontSize: '1.1em',
                                        marginBottom: '0.5em'
                                    }}>
                                        {option.label}
                                    </div>
                                    <div style={{
                                        width: '0.8em',
                                        height: '0.8em',
                                        borderRadius: '50%',
                                        background: this.state.monthlyVisits === option.value ? '#0767F4' : '#E0E0E0',
                                        margin: '0 auto'
                                    }} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Кнопка отправки */}
                <div className="whiteBlockButtonBlock">
                    <button 
                        onClick={this.props.doSave}
                        className='whiteBlockButton'
                        disabled={this.props.isLoading || !this.props.website_name || !this.props.website_url}
                        style={{
                            opacity: (this.props.isLoading || !this.props.website_name || !this.props.website_url) ? 0.5 : 1,
                            cursor: (this.props.isLoading || !this.props.website_name || !this.props.website_url) ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {this.props.isLoading ? 'Сохранение...' : 'Добавить сайт'}
                    </button>
                </div>
            </div>
        );
    }
}